import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LicenseStudyAreas } from 'src/app/predictor-enterprise-license/shared/interface/License-Study-Areas';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LicenseStudyAreaServiceService {
  private readonly baseUrl = '/api/License'; // Change to your actual backend endpoint
  private readonly baseUrlStudyArea = '/api/StudyAreas'; // Change to your actual backend endpoint for study areas

  constructor(private readonly http: HttpClient) { }

  private readonly stepIndexSource = new BehaviorSubject<number>(0);
  currentStep$ = this.stepIndexSource.asObservable();

  private readonly drawnAreaSource = new BehaviorSubject<any>(0);
  drawnAreaSource$ = this.drawnAreaSource.asObservable();

  private readonly selectedStudyAreaSource =
    new BehaviorSubject<LicenseStudyAreas | null>(null);
  selectedStudyArea$ = this.selectedStudyAreaSource.asObservable();

  public licenseStudyAreaData = new BehaviorSubject<any[]>([]);

  getLicenseStudyAreaData(): Observable<any[]> {
    return this.licenseStudyAreaData.asObservable();
  }

  // Public setter – to push data into the subject
  setLicenseStudyAreaData(data: any[]) {
    this.licenseStudyAreaData.next(data);
  }

  // Set all fields except studyAreaName
  setPartialStudyAreaDetails(details: Partial<LicenseStudyAreas>) {
    const current = this.selectedStudyAreaSource.getValue() || {};
    const updated = { ...current, ...details };
    this.selectedStudyAreaSource.next(updated);
  }

  setDrawnAreaDetails(drawnArea: any) {  
    this.drawnAreaSource.next(drawnArea);
  }

  // Update only studyAreaName later
  setStudyAreaName(name: string) {
    const current = this.selectedStudyAreaSource.getValue() || {};
    const updated = { ...current, studyAreaName: name };
    this.selectedStudyAreaSource.next(updated);
  }

  setStep(index: number) {
    this.stepIndexSource.next(index);
  }

  setSelectedStudyArea(area: LicenseStudyAreas) {
    this.selectedStudyAreaSource.next(area);
  }

  getAll(): Observable<LicenseStudyAreas[]> {
    return this.http.get<LicenseStudyAreas[]>(this.baseUrl);
  }

  getById(licenseNumber: string): Observable<LicenseStudyAreas[]> {
    return this.http.get<LicenseStudyAreas[]>(
      this.baseUrlStudyArea + '/licenseNumber/' + licenseNumber
    );
  }

  create(license: LicenseStudyAreas): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrlStudyArea, license);
  }

  update(
    id: string,
    license: LicenseStudyAreas
  ): Observable<LicenseStudyAreas> {
    return this.http.put<LicenseStudyAreas>(`${this.baseUrl}/${id}`, license);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  isUniqueStudyAreaNameForGivenLicense(
    studyAreaName: string,
    licenseNumber: string
  ): Observable<boolean> {
    return this.http.get<boolean>(
      `/api/studyareas/exist?studyAreaName=${studyAreaName}&licenseNumber=${licenseNumber}`
    );
  }

  public reviewStudyAreaDetails(studyAreaName: string, stepNumber: number) {
    this.setStep(stepNumber);
  }
}
